// extracted by mini-css-extract-plugin
module.exports = {"Container":"BlockBorderAnimation_Container___ODyQ","FullHeight":"BlockBorderAnimation_FullHeight___ooKA","Active":"BlockBorderAnimation_Active__A4NC2"};